const initialState = {
	// tmout: 0,
	serverTime: new Date().toISOString()
}

export default function timeReducer(state = initialState, action) {
	switch (action.type) {
		case 'SET_SERVERTIME': {
			return {
				...state,
				serverTime: action.serverTime || new Date().toISOString()
			}
		}
		default:
			return state
	}
}